import Vue from "vue";

const auth = {
  namespaced: true,
  state: {
    item: {
      apiKey: null,
      userId: null,
      username: null,
    },
  },
  mutations: {
    setAuth(state, payload) {
      this.commit("resetData");
      state.item = payload;
    },
    unsetAuth(state) {
      state.item = {
        apiKey: null,
        userId: null,
        username: null,
      };
    },
  },
  actions: {
    login: function (context, form) {
      Vue.prototype.$axios.post("login", form).then((response) => {
        if (
          response.data.apiKey &&
          response.data.userId &&
          response.data.username
        ) {
          this.commit("auth/setAuth", {
            apiKey: response.data.apiKey,
            userId: response.data.userId,
            username: response.data.username,
          });
        }
      });
    },
  },
  getters: {},
};

export default auth;
